'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var ReactDOM = require('react-dom');
var motion = require('../theme/motion.js');
var objToStyle = require('../utils/objToStyle.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  max-width: 240px;\n  background: #ece4f6;\n  padding: 12px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n\n  z-index: 10;\n  position: absolute;\n  text-decoration: none;\n  word-wrap: break-word;\n  display: flex;\n  animation: ", ";\n  visibility: ", ";\n  ", "\n\n  &:before {\n    content: '';\n    position: absolute;\n    display: block;\n    width: 0px;\n  }\n  &.top {\n    &:before {\n      left: 50%;\n      bottom: 0;\n      border: 10px solid transparent;\n      border-top: 10px solid #ece4f6;\n      transform: translate(-50%, 100%);\n    }\n  }\n  &.bottom {\n    &:before {\n      left: 50%;\n      top: 0;\n      border: 10px solid transparent;\n      border-bottom: 10px solid #ece4f6;\n      transform: translate(-50%, -100%);\n    }\n  }\n  &.right {\n    &:before {\n      left: 0;\n      top: 50%;\n      border: 10px solid transparent;\n      border-right: 10px solid #ece4f6;\n      transform: translate(-100%, -50%);\n    }\n  }\n  &.left {\n    &:before {\n      right: 0;\n      top: 50%;\n      border: 10px solid transparent;\n      border-left: 10px solid #ece4f6;\n      transform: translate(100%, -50%);\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var rect = null;
var StyledTooltip = styled__default['default'].div(_templateObject(), function (props) {
  return props.show ? motion.motionIn : motion.motionOut;
}, function (props) {
  return props.open ? 'visible' : 'hidden';
}, function () {
  return rect && objToStyle['default'](rect);
});

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      prompt = _ref.prompt,
      position = _ref.position,
      className = _ref.className,
      _ref$portal = _ref.portal,
      portal = _ref$portal === void 0 ? 'modal-root' : _ref$portal,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 15 : _ref$offset,
      restProps = _objectWithoutProperties(_ref, ["children", "prompt", "position", "className", "portal", "offset"]);

  /**
   * "show" is set immedietly on mouse move
   * to track when to target the display or
   * hide animation whereas, "open" is
   * set to track when the animation ends
   */
  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var ref = React.useRef();
  React.useEffect(function () {
    show && setOpen(true);
  }, [show]);
  var animationProps = {
    animationName: 'zoomBig',
    animationDuration: motion.durationBase
  };
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].cloneElement(children, {
    onMouseEnter: function onMouseEnter(event) {
      var target = event.currentTarget.getBoundingClientRect();
      var _ref$current = ref.current,
          clientHeight = _ref$current.clientHeight,
          clientWidth = _ref$current.clientWidth;

      switch (position) {
        case 'right':
          rect = {
            transformOrigin: "-".concat(offset, "px 50%"),
            left: "".concat(target.right + offset, "px"),
            top: "".concat(target.top + target.height / 2 + window.scrollY - clientHeight / 2, "px")
          };
          break;

        case 'left':
          rect = {
            transformOrigin: "".concat(target.width - offset, "px 50%"),
            left: "".concat(target.left - clientWidth - offset, "px"),
            top: "".concat(target.top + target.height / 2 + window.scrollY - clientHeight / 2, "px")
          };
          break;

        case 'bottom':
          rect = {
            transformOrigin: "50% -".concat(offset, "px"),
            left: "".concat(target.left + target.width / 2 - clientWidth / 2, "px"),
            top: "".concat(target.top + target.height + window.scrollY + offset, "px")
          };
          break;

        case 'top':
        default:
          rect = {
            transformOrigin: "50% ".concat(target.height - offset, "px"),
            left: "".concat(target.left + target.width / 2 - clientWidth / 2, "px"),
            top: "".concat(target.top - clientHeight + window.scrollY - offset, "px")
          };
          break;
      }

      setShow(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShow(false);
    }
  }), /*#__PURE__*/ReactDOM__default['default'].createPortal( /*#__PURE__*/React__default['default'].createElement(StyledTooltip, _extends({}, animationProps, restProps, {
    className: "".concat(className, " ").concat(position),
    onAnimationEnd: function onAnimationEnd() {
      !show && setOpen(false);
    },
    ref: ref,
    show: show,
    open: open
  }), prompt), document.getElementById(portal)));
};

Tooltip.propTypes = {
  children: PropTypes__default['default'].node,
  prompt: PropTypes__default['default'].string,
  position: PropTypes__default['default'].oneOf(['top', 'bottom', 'right', 'left']),
  className: PropTypes__default['default'].string,
  portal: PropTypes__default['default'].string,
  offset: PropTypes__default['default'].number
};
Tooltip.defaultProps = {
  position: 'top'
};

exports.default = Tooltip;
